const $ = jQuery.noConflict();

'use strict';
const Global = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domWindow: $(window),
	$domDoc: $(document),
	$domBody: $('body'),
	varsWindowWidth: window.innerWidth,

	/**
	 * @description do something on escape key click
	 * @example Global.functions.escKey(closeNav);
	 * @param {function} callback - pass callback function
	 */
	escKey: function(callback) {
		Global.$domDoc.on('keyup', function(e) {
			if (e.keyCode === 27) {
				callback();
			}
		});
	},

	/**
	 * @description Click outside container to close it (e.g. popups, menu...)
	 * @example Global.functions.clickOutsideContainer(this.$domMenuNav, this.$domMenuNav.children('ul'), this.$domMenuBtn, closeNav);
	 * @param {jQuery} selector - element that trigger function ( e.g. $('body') );
	 * @param {jQuery} container - popup wrapper
	 * @param {jQuery} closeBtn - close button
	 * @param {function} callback - callback function
	 */
	clickOutsideContainer: function(selector, container, closeBtn, callback) {
		selector.on('mouseup', function(e) {
			e.preventDefault();
			if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
				callback();
			}
		});
	},

	/**
	 * @description Equal height function for multiple elements. This function should be used on load and on resize also.
	 * @example Global.functions.equalHeights('.some-element-class');
	 * @example $(window).on('resize', ()=> { Global.functions.equalHeights('.some-element-class'); });
	 * @param {jQuery} elm - element class
	 */
	equalHeights: (elm) => {
		let x = 0;
		elm.height('auto');

		elm.each((index, el) => {
			if ($(el).height() > x) {
				x = $(el).height();
			}
		});

		elm.height(x + 1);
	},

	scrollTo: (selector) => {
		$(selector).on('click', (e) => {
			e.preventDefault();
			const target = $(e.currentTarget.hash);

			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top
				}, 1000);
				return false;
			}
		});
	},

	setCookie: function(name, value, time = '01 Jan 1970 00:00:00 UTC', path = '/') {
		const ua = window.navigator.userAgent;

		// IE 10 and lower versions
		// const msie = ua.indexOf('MSIE');

		// IE 11
		const trident = ua.indexOf('Trident/');

		if (!(trident > 0)) {
			time = '';
		}

		document.cookie = name + '=' + JSON.stringify(value) + '; expires=' + time + '; path=' + path + ';';
	},

	readCookie: function(name) {
		const nameEQ = name + '=';
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) {
				return JSON.parse(
					c.substring(nameEQ.length, c.length)
				);
			}
		}
		return null;
	},
	getAllUrlParams(params) {
		const keyPairs = {};
		if (!params) {
			params = window.location.search.substring(1).split('&');
		}
		for (let i = params.length - 1; i >= 0; i--) {
			const paramsSplit = params[i].split('=');
			keyPairs[paramsSplit[0]] = paramsSplit[1];
		}
		return keyPairs;
	},
	checkActive(name) {
		const queryString = Global.getAllUrlParams();
		if (location.search !== '' && queryString[name] !== undefined) {
			return ' ' + queryString[name].replace(/'+'/g, ' ') + ' ';
		} else {
			return '';
		}
	},
	getParamsCookie(params) {
		if (!params || params === '') {
			return false;
		}
		const keyPairs = {};
		const cookie = params.split('&');
		for (let i = cookie.length - 1; i >= 0; i--) {
			const paramsSplit = cookie[i].split('=');
			keyPairs[paramsSplit[0]] = paramsSplit[1];
		}
		return keyPairs;
	},
	deleteCookie: function(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 20 Jun 1989 00:00:01 GMT;';
	},

	/**
	 * @description change images url from http to https
	 *
	 * @param images
	 */
	imagesSrcHttps: function(images) {
		const protocol = location.protocol;
		let newUrl = '';
		for (let i = 0; i < images.length; i++) {
			if (protocol === 'https:') {
				newUrl = images[i].getAttribute('src').replace('http://', 'https://');
			}
			if (protocol === 'http:') {
				newUrl = images[i].getAttribute('src').replace('https://', 'http://');
			}

			images[i].setAttribute('src', newUrl);
			if (images[i].hasAttribute('data-src')) {
				let newUrlDataSrc = '';
				if (protocol === 'https:') {
					newUrlDataSrc = images[i].getAttribute('data-src').replace('http://', 'https://');
				}
				if (protocol === 'http:') {
					newUrlDataSrc = images[i].getAttribute('data-src').replace('https://', 'http://');
				}
				images[i].setAttribute('data-src', newUrlDataSrc);
			}
		}
	},

	/**
	 * @description change element background url from http to https
	 *
	 * @param elements
	 */
	elementsBackgroundImgHttps: function(elements) {
		const protocol = location.protocol;
		for (let i = 0; i < elements.length; i++) {
			const newUrl = elements[i].style.backgroundImage.slice(4, -1).replace(/'/g, '');
			if (protocol === 'https:') {
				elements[i].style.backgroundImage = 'url(' + newUrl.replace('http://', 'https://') + ')';
			}
			if (protocol === 'http:') {
				elements[i].style.backgroundImage = 'url(' + newUrl.replace('https://', 'http://') + ')';
			}
		}
	},
};

export default Global;
